import React from 'react';
// import PropTypes from 'prop-types';

import {dispatch, connect} from 'utils/state_manager';

import {Typography, Link, Box, Stack} from 'views/components';
import {Translate} from 'views/module';

const NavbarLogo = () => {
  return (
    <Stack
      direction={'row'}
      spacing={1}
      alignItems={'center'}
    >
      <Box/>
      <span
        title='Logged in'
        style={{
          borderRadius: '50%',
          backgroundColor: '#00b400',
          width: '8px',
          height: '8px',
        }}
      />
      <Link
        href='/'
        underline='none'
      >
        <Typography
          sx={{
            'color': 'navbar.text',
            'fontWeight': 500,
            'fontSize': '24px',
            'display': 'inline-block',
            'fontFamily': 'Mono',
          }}
        >
          <Translate expression='generic.CareOS' />
        </Typography>
      </Link>
    </Stack>
  );
};

NavbarLogo.propTypes = {
};
const mapStateToProps = (state) => ({
});

export default connect(mapStateToProps, dispatch)(React.memo(NavbarLogo));
